import { QueryClient } from '@tanstack/react-query';

/**
 * QueryClient compartido. Defaults conservadores para no cambiar el
 * comportamiento de pantallas que no hayan migrado todavía:
 *
 * - `staleTime: 30s`: evita refetch innecesarios en navegación rápida.
 * - `refetchOnWindowFocus: false`: no sorprende al usuario al volver al tab.
 * - `retry: 1`: un reintento es suficiente (el httpClient ya reintenta
 *   a nivel de red para idempotentes).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
    mutations: {
      retry: 0,
    },
  },
});
